import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { EmojiData } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { connectState } from '@examdojo/angular/util';
import { ColorSchemeService } from '@examdojo/browser/color-scheme';
import { Icon } from '@examdojo/core/icon';
import { StopPropagationDirective } from '@examdojo/core/stop-propagation';
import { UntilDestroy } from '@ngneat/until-destroy';

export interface PickerIcon {
  icon?: Icon;
  color?: string;
  emoji?: string;
}

@UntilDestroy()
@Component({
  selector: 'dojo-icon-picker',
  templateUrl: './icon-picker.component.html',
  styleUrl: './icon-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PickerComponent, StopPropagationDirective],
})
export class IconPickerComponent {
  constructor(private readonly userColorSchemeService: ColorSchemeService) {}

  readonly perLine = input(9);
  readonly emojiSize = input(24);
  readonly autoFocus = input(true);
  readonly showPreview = input(true);
  readonly enableSearch = input(false);

  @Output() iconSelected = new EventEmitter<PickerIcon>();

  readonly state = connectState({
    darkMode: this.userColorSchemeService.hasDarkMode$,
  });

  selectEmoji({ native }: EmojiData) {
    this.iconSelected.next({
      emoji: native,
    });
  }
}
